import { faCloudCheck, faFloppyDisk } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IForm } from "form/model"
import { getFormChangesCount } from "form/tools/change"
import { isCreateForm } from "form/tools/common"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IChangeCountProps {
  form: IForm
  sx?: any
}

export const ChangeCount = React.memo(({ form, sx }: IChangeCountProps): JSX.Element => {
  const count: number = getFormChangesCount(form.changes)
  return (
    <FlexBox
      id="form-change-count"
      sx={{
        "gap": ".4rem",
        "& .icon": {
          color: theme => (count > 0 ? theme.palette.primary.main : theme.palette.text.secondary),
          fontSize: "1.2rem"
        },
        ...sx
      }}>
      <FontAwesomeIcon icon={isCreateForm(form) || count > 0 ? faFloppyDisk : faCloudCheck} className="icon" />
      <Typography id="form-change-count-text" color="textSecondary" sx={{ fontSize: ".8rem" }}>
        {count === 0
          ? translate("label.no.change")
          : count === 1
            ? translate("label.one.change")
            : translate("label.change.count", count)}
      </Typography>
    </FlexBox>
  )
})
